import { array, boolean, number, object } from 'yup';
import { BOXES } from '../constants';

const boxDefinitionSchema = object({
  products: array(
    object({
      quantityRemaining: number().integer().equals([0]).required(),
    }),
  ),
});

export const DefineShipmentsSchema = object({
  [BOXES]: array(boxDefinitionSchema).ensure(),
  isComplete: boolean(),
});
